import { render, staticRenderFns } from "./loteEstoque.vue?vue&type=template&id=1a43eed0"
import script from "./loteEstoque.ts?vue&type=script&lang=js&external"
export * from "./loteEstoque.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a43eed0')) {
      api.createRecord('1a43eed0', component.options)
    } else {
      api.reload('1a43eed0', component.options)
    }
    module.hot.accept("./loteEstoque.vue?vue&type=template&id=1a43eed0", function () {
      api.rerender('1a43eed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacaoNew/lotesEstoque/loteEstoque.vue"
export default component.exports